import React, { useState } from 'react';
import { Mail, Phone, MapPin, User } from 'lucide-react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const ConnectWithUsForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    email: false,
    mobile: false
  });

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobileRegex = /^[6-9]\d{9}$/;

  const handleChange = (e) => {
    const { id, value } = e.target;

    // Limit the mobile number to 10 characters
    if (id === 'mobile' && value.length <= 10) {
      setFormData({
        ...formData,
        [id]: value
      });
    } else if (id !== 'mobile') {
      setFormData({
        ...formData,
        [id]: value
      });
    }

    // Validate the email and mobile number for errors
    if (id === 'email') {
      setErrors((prev) => ({ ...prev, email: !emailRegex.test(value) }));
    }

    if (id === 'mobile') {
      setErrors((prev) => ({ ...prev, mobile: !mobileRegex.test(value) }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await fetch('https://100billionrealestate.com/gas-stove/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) throw new Error('Submission failed.');

      const result = await response.json();
      toast.success('Message sent successfully!');
      setFormData({ name: '', email: '', mobile: '', message: '' });
    } catch (error) {
      toast.error('Failed to send message. Try again later.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="connect-us-hob-wrapper">
        <div className="connect-us-hob-container">
          {/* Left: Form */}
          <div className="connect-us-hob-form-section">
            <h2 className="connect-us-hob-title">Connect With Us</h2>
            <form className="connect-us-hob-form" onSubmit={handleSubmit}>
              <div className="connect-us-hob-group">
                <label htmlFor="name">Name</label>
                <div className="connect-us-hob-input-icon">
                  <User size={18} />
                  <input
                    type="text"
                    id="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="connect-us-hob-group">
                <label htmlFor="email">Email</label>
                <div className={`connect-us-hob-input-icon ${errors.email ? 'input-error' : ''}`}>
                  <Mail size={18} />
                  <input
                    type="email"
                    id="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="connect-us-hob-group">
                <label htmlFor="mobile">Mobile Number</label>
                <div className={`connect-us-hob-input-icon ${errors.mobile ? 'input-error' : ''}`}>
                  <Phone size={18} />
                  <input
                    type="tel"
                    id="mobile"
                    placeholder="1234567890"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="connect-us-hob-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  rows="4"
                  placeholder="Write your message..."
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="connect-us-hob-button" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>

          {/* Right: Contact Info */}
          <div className="connect-us-hob-info-section">
            <h3>Contact Info</h3>

            <div className="connect-us-hob-info-card">
              <Phone size={20} />
              <div>
                <span>Phone</span>
                +91-70390 34000, +91 70390 44000
              </div>
            </div>

            <div className="connect-us-hob-info-card">
              <Mail size={20} />
              <div>
                <span>Email</span>
                royalambulance@gmail.com
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default ConnectWithUsForm;
